// extracted by mini-css-extract-plugin
export var arrow = "_2f-6";
export var changeItem = "_2f-3";
export var changesHeader = "_2f-1";
export var changesList = "_2f-2";
export var container = "_2f-0";
export var pathLabel = "_2f-4";
export var value = "_2f-7";
export var valuesContainer = "_2f-5";